<app-stage [showChatButton]="showChatButton$ | async">
  <router-outlet></router-outlet>
</app-stage>